module.exports = __webpack_public_path__ + "img/26.f5117ed5.gif";